import { LifeBuoy } from 'lucide-react';
import { supabase } from '../lib/supabase';
import SwipeOpinionLogo from '../components/brand/SwipeOpinionLogo';

/**
 * Dead-end screen for an ejected member (suspended / blocked / deleted). Shown
 * when the member-load front door returns 403 `ACCOUNT_INELIGIBLE`. Deliberately
 * calm and reason-free: no status/score/detail, no retry, no self-service
 * unblock — the only path forward is talking to member care. Mirrors
 * GeoBlockedPage so the two blocked states feel like one family.
 */
export default function AccountIneligiblePage() {
  async function handleSignOut() {
    await supabase.auth.signOut().catch(() => {});
    window.location.href = '/login';
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#5B4FE8] via-[#4338CA] to-teal-500 relative overflow-hidden px-4">
      <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-white/10" />
      <div className="absolute bottom-32 right-16 w-48 h-48 rounded-full bg-white/5" />
      <div className="relative max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center">
        <SwipeOpinionLogo variant="full" className="justify-center mb-4" markClassName="w-5 h-5" wordmarkClassName="text-base font-semibold text-navy" />
        <div className="mx-auto w-16 h-16 rounded-full bg-[#F3F0FF] flex items-center justify-center mb-4">
          <LifeBuoy className="w-8 h-8 text-[#5B4FE8]" />
        </div>
        <h1 className="text-2xl font-semibold text-[#111827] mb-3">
          Let&rsquo;s sort this out
        </h1>
        <p className="text-[#6B7280] mb-2">
          There&rsquo;s something to resolve with your account before you can keep
          using Swipe Opinion.
        </p>
        <p className="text-[#6B7280] mb-6 text-sm">
          Send our member care team a note and we&rsquo;ll help you from there.
        </p>
        <a
          href="mailto:hello@swipeopinion.com"
          className="inline-flex items-center justify-center w-full bg-[#5B4FE8] hover:bg-[#4338CA] text-white font-medium rounded-xl px-5 py-3 mb-4 transition-colors"
        >
          Contact member care
        </a>
        <button
          type="button"
          onClick={() => void handleSignOut()}
          className="text-sm text-[#6B7280] hover:text-[#111827] font-medium transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
